import { AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api/api.service';
import { EstateControlService } from 'src/app/services/estate-control.service';
import { TabControlService } from 'src/app/services/tab-control.service';
import { createIDsValidatorEstate } from 'src/app/services/validators/custom.validators';
import { ValidationService } from 'src/app/services/validators/validation.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import * as Constants from "src/app/constants/constants";
import { ExpansionPanel } from 'src/app/components/section/section.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-step6-witness',
  templateUrl: './step6-witness.component.html',
  styleUrls: ['./step6-witness.component.scss']
})
export class Step6WitnessComponent implements OnInit, AfterViewChecked, OnDestroy {
  checkerPath: string = `${environment.hRef}assets/fi_check.png`;

  title: string = 'Witnesses to the Will';
  subtitle: string = 'Witnesses to the Will are mandatory. Please choose below if you want to add witnesses now or include them after the Will is prepared.';
  subtitleAlt: string = 'Witnesses to the Will are mandatory. Please add all witnesses you would like to include in the Will below:';

  witnessFormVisible: boolean = false;

  detailsTitle: string = 'Witness Details';

  titleLabel: string = 'Title';
  titleHint: string = 'Title';
  fNameLabel: string = 'First Name';
  fNameHint : string = 'First name';
  mNameLabel : string = 'Middle Name';
  mNameHint : string = 'Middle name';
  surnameLabel : string = 'Surname';
  surnameHint : string = 'Last name';
  phoneLabel : string = 'Mobile Number';
  emailLabel : string = 'Email Address';
  emailHint : string = 'Email address';

  idLabel: string = 'ID/Passport Number';
  idHint: string = 'Enter ID or Passport Number';
  postalLabel: string = 'Postal Address';
  postalHint: string = 'Enter Postal Address';

  idFileLabel: string = 'Upload copy of ID (front + back) / Passport';
  kraFileLabel: string = 'Upload copy of KRA PIN';
  photoLabel: string = 'Upload Passport Photo';

  addWitnessText: string = '+  Add Another Witness';
  removeWitnessText: string = 'Remove Witness';
  removeButtonText: string = this.removeWitnessText;

  requiredFieldString: string = 'Required field';

  loadingText: string = 'Saving Documents';
  loadingRemove: boolean = false;
  addWitnesses: boolean = true;
  currentIndex: number = 0;


  formErrors: { [key: string]: string } = {
    Title: '',
    FirstName: '',
    MiddleName: '',
    LastName: '',
    Phone: '',
    Email: '',
    IDNo: '',
    KraPin: '',
    PostalAddress: '',

    IDNoImage: '',
    KraPinImage: '',
    PassportImage: ''
  };

  validationMessages: { [key: string]: {} } = {
    Title: { required: this.requiredFieldString },
    FirstName: { required: this.requiredFieldString },
    MiddleName: { required: this.requiredFieldString },
    LastName: { required: this.requiredFieldString },
    Phone: { required: this.requiredFieldString, pattern:'Invalid phone number', exist: 'This number is tied to an existing witness' },
    Email: { required: this.requiredFieldString, email: "Invalid email address", exist: 'This email is tied to an existing witness' },
    IDNo:  { required: this.requiredFieldString, min:'Invalid ID or Passport number', exist: 'This ID is tied to an existing witness' },
    KraPin: { required: this.requiredFieldString, pattern:'Invalid KRA PIN', exist: 'This PIN is tied to an existing witness' },
    PostalAddress: { required: this.requiredFieldString },

    IDNoImage: { required: this.requiredFieldString },
    KraPinImage: { required: this.requiredFieldString },
    PassportImage: { required: this.requiredFieldString }
  };


  witnessPanels: ExpansionPanel[][] = [];
  private formChangesSubscription: Subscription[] = [];
  panelsInitialized: boolean = false;

  witnessForm = this._formBuilder.group({
  }) as FormGroup & { [key: string]: AbstractControl };

  constructor(
    private _formBuilder: FormBuilder,
    private notificationService: NotificationService,
    private tabControlService: TabControlService,
    public estateControlService: EstateControlService,
    private validationService: ValidationService,
    private apiService: ApiService,
    private cdr: ChangeDetectorRef
  ) {
    this.populateData();
  }

  async ngOnInit(): Promise<void> {
    if (this.witnesses && this.witnesses.length > 0) {
      // Filter out the unverified testators and reassign the array
      const dat = this.witnesses.filter((witness: any) => witness.verified == true);
      await this.estateControlService.updateRecordWill(6, dat);

      const firstObject = this.witnesses[0];

      if (firstObject && firstObject.verified == true) {
        this.addWitnessesArray(firstObject);
        // Add witnesses from storage
        this.witnesses.forEach((witness: any, index: number) => {
          if (index > 0 && witness.verified == true) {
            const fields = this.witnessForm.get('witnesses') as FormArray;
            fields.push(this.createWitnessFormGroup(witness));
            this.witnessForm.setControl('witnesses', fields);
          }
        });
        this.witnessFormVisible = true;
        // Initialize all witnessPanels with their FormGroup already created
        setTimeout(()=> {  
          this.getWitnesses().controls.forEach((_, i) => {
            if (!this.witnessPanels[i]) {
              this.witnessPanels[i] = this.generatePanelsForWitness(i);
            }
          });
        })
        
      }
    }

    this.witnessForm.valueChanges.subscribe(()=> {
      this.logErrors();
    })
  }
  ngAfterViewChecked() {
    if (!this.panelsInitialized && this.witnessFormVisible) {
      this.initializePanels();
      this.panelsInitialized = true;
    }
  }
  ngOnDestroy(): void {
    this.cleanupFormChangeListeners();
  }

  logErrors() {
    this.formErrors = this.validationService.logValidationErrors(
      this.witnessForm,
      this.formErrors,
      this.validationMessages
    );
  }

  private initializePanels() {
    this.witnesses.forEach((_: any, i: number) => {
        if (!this.witnessPanels[i]) {
          this.witnessPanels[i] = this.generatePanelsForWitness(i);
        }
      });
    this.cdr.detectChanges();
  }

  get region(): any {
    return this.estateControlService.regionType;
  }
  get witnesses(): any {
    return this.estateControlService.witnesses;
  }
  get loading(): boolean {
    return this.notificationService.loading;
  }
  get loadingTitles(): boolean {
    return this.tabControlService.loadingTitles;
  }
  get TitleOptions(): any {
    return this.tabControlService.TitleOptions;
  }

  get saveProgress(): ()=> void {
    return this.estateControlService.saveProgress;
  }

  updateIDObject(index: number, object: any): void {
    const currents = this.witnesses;
    const latestRecord = currents[index];
    let updatedRecord = {
      ...latestRecord,
      ...{IDNoImage: object}
    };

    Object.assign(currents[index], updatedRecord);
    this.estateControlService.updateRecordWill(6, currents);
  }
  updateKraObject(index: number, object: any): void {
    const currents = this.witnesses;
    const latestRecord = currents[index];
    let updatedRecord = {
      ...latestRecord,
      ...{KraPinImage: object}
    };

    Object.assign(currents[index], updatedRecord);
    this.estateControlService.updateRecordWill(6, currents);
  }
  updatePhotoObject(index: number, object: any): void {
    const currents = this.witnesses;
    const latestRecord = currents[index];
    let updatedRecord = {
      ...latestRecord,
      ...{PassportImage: object}
    };

    Object.assign(currents[index], updatedRecord);
    this.estateControlService.updateRecordWill(6, currents);
  }

  async populateData(): Promise<void> {
    if (this.TitleOptions.length === 0 && !this.tabControlService.loadingTitles) {
      this.tabControlService.loadingTitles = true;
      await this.tabControlService.getTitlesList();
      this.tabControlService.loadingTitles = false;
    }
  }

  async populateForm(): Promise<void> {
    if (!(this.witnesses && this.witnesses.length > 0)) {
      this.addWitnessesArray();
    }
    this.witnessFormVisible = true;
  }

  onOptionChange(value: boolean): void {
    this.addWitnesses = value;
  }

  addWitnessesArray = (witness: any = null) => {
    this.witnessForm.addControl('witnesses', this._formBuilder.array([
      this.createWitnessFormGroup(witness)
    ]));
    this.setupFormChangeListeners();
  }
  createWitnessFormGroup(witness: any = null): FormGroup {
    let form: FormGroup;

    // console.log('scajhbusdycbudsb ', witness);

    if (witness) {
      form = this._formBuilder.group({
        Title: [`${witness.Title || ''}`],
        FirstName: [`${witness.FirstName || ''}`, Validators.required],
        MiddleName: [`${witness.MiddleName || ''}`,],
        LastName: [`${witness.LastName || ''}`, Validators.required],
        Phone: [`${witness.Phone || ''}`, Validators.required],
        Email: [`${witness.Email || ''}`, [Validators.required, Validators.email]],
        IDNo: [`${witness.IDNo || ''}`, Validators.required],
        PostalAddress: [`${witness.PostalAddress || ''}`, Validators.required],

        IDNoImage: [],
        KraPinImage: [],
        PassportImage: []
      });

      if (witness.IDNoImage) {
        form.get('IDNoImage')?.setValue(witness.IDNoImage.stringValue);
      }
      if (witness.KraPinImage) {
        form.get('KraPinImage')?.setValue(witness.KraPinImage.stringValue);
      }
      if (witness.PassportImage) {
        form.get('PassportImage')?.setValue(witness.PassportImage.stringValue);
      }

      if (witness.verified) {
        this.validationService.addOrRemoveValidator(true, form.get('IDNoImage')!);
        if (this.region === 0) this.validationService.addOrRemoveValidator(true, form.get('KraPinImage')!);
        this.validationService.addOrRemoveValidator(true, form.get('PassportImage')!); 
      }
      
    } else {
      if (
        this.witnesses && this.witnesses.length > 0 && this.witnesses[0].verified == false
      ) {
          this.estateControlService.refreshRecordWill(6);
      }

      let currentWitnesses = this.witnesses;
      let currentRecord: any = {verified: false, done: false};

      form = this._formBuilder.group({
        Title: [''],
        FirstName: ['', Validators.required],
        MiddleName: [''],
        LastName: ['', Validators.required],
        Phone: ['', Validators.required],
        Email: ['', [Validators.required, Validators.email]],

        IDNo: ['', Validators.required],
        PostalAddress: ['', Validators.required],

        IDNoImage: [],
        KraPinImage: [],
        PassportImage: []
      });

      if (
        this.witnesses.length == 0 ||
        this.witnesses.length > 0 && this.witnesses[this.witnesses.length-1].done == true
      ) {
        currentWitnesses.push(currentRecord);
        this.estateControlService.updateRecordWill(6, currentWitnesses);
      }
      
    }

    if (this.witnessForm && this.getWitnesses() && this.getWitnesses().length > 0) {
      this.validationService.addOrRemove3Validators(
        true,
        form.get('Email')!,
        [Validators.required,
          Validators.email,
          createIDsValidatorEstate('EMAIL', this.getWitnesses(), this.witnesses)
        ]
      );
      this.validationService.addOrRemoveSpecificValidators(
        true,
        form.get('Phone')!,
        [Validators.required,
          createIDsValidatorEstate('TEL', this.getWitnesses(), this.witnesses)
        ]
      );
      this.validationService.addOrRemove3Validators(
        true,
        form.get('IDNo')!,
        [Validators.required,
          Validators.min(4),
          createIDsValidatorEstate('ID', this.getWitnesses(), this.witnesses)
        ]
      );
    }

    form.updateValueAndValidity();

    return form;
  };
  async addNewWitness() {
    const fields = this.witnessForm.get('witnesses') as FormArray;
    const newFormGroup = this.createWitnessFormGroup()
    fields.push(newFormGroup);
    this.witnessForm.setControl('witnesses', fields);
    
    // Wait for view to update
    await new Promise(resolve => setTimeout(resolve));
    const newIndex = fields.length - 1;
    this.witnessPanels[newIndex] = this.generatePanelsForWitness(newIndex);

    // Set up listeners after panels are generated
    this.setupFormChangeListenersForIndex(newIndex);
    this.cdr.detectChanges();
  }
  async removeWitness(i:number) {
    this.currentIndex = i;
    const fields = this.witnessForm.get('witnesses') as FormArray;
    let currentWitnesss = this.witnesses;
    
    if (currentWitnesss[i] && currentWitnesss[i].WitnessID) {
      this.removeButtonText = 'Removing Witness';
      this.loadingRemove = true;
      
      try {
        if (this.estateControlService.TrustID !== null) {
          const result = await this.estateControlService.removeRecord(
            'witness',
            currentWitnesss[i].WitnessID,
            parseInt(this.estateControlService.TrustID),
            environment.baseUrl + Constants.willWitnessURL
          );

          if (result === 1) {
            this.notificationService.viewToast('success', 'Witness removed successfully');
            fields.removeAt(i);
            // Remove witness at index
            currentWitnesss.splice(i, 1);;
            await this.estateControlService.updateRecordWill(6, currentWitnesss);
          } else {
            this.notificationService.viewToast('error', 'Error removing record');
          }
        } else {
          console.log('Relevant IDs not found');
        }
      } catch (error) {
        console.log(':: Error !! ', error);
      }
      this.removeButtonText = 'Remove Witness';
      this.loadingRemove = false;
    } else {
      if (currentWitnesss[i] && currentWitnesss[i].done === false) {
        fields.removeAt(i);
        // Remove witness at index
        currentWitnesss.splice(i, 1);;
        await this.estateControlService.updateRecordWill(6, currentWitnesss);
      } else {
        fields.removeAt(i);
      }
    }
    if (this.getWitnesses().length < 1) this.addNewWitness();
    setTimeout(()=> {
      this.generatePanelsForWitness(i);
      this.witnesses.forEach((ben: any, index: number) => {
        this.updateDoneStatus(index, ben);
      });
    })
  }
  getWitnesses() : FormArray {  
    return this.witnessForm.get("witnesses") as FormArray  
  }
  getWitnessFormGroup(index: number): FormGroup {
    const witnesses = this.witnessForm.get('witnesses') as FormArray;
    return witnesses.at(index) as FormGroup;
  }

  async saveWitness(index?: any): Promise<void> {
    if (index || this.witnesses[this.witnesses.length-1].verified == true)
      this.loadingText = 'Updating Witness';
    else this.loadingText = 'Saving Witness';

    let tsMessage = 'Witness details saved';
    this.notificationService.isLoading(true);

    try {
      const witnesses = this.witnessForm.get('witnesses') as FormArray;
      const currentIndex = index ?? witnesses.length - 1;
      const record: FormGroup = this.getWitnessFormGroup(currentIndex) as FormGroup;
      
      let data = {
        ...record.getRawValue(),
        ...{
          TrustID: this.estateControlService.TrustID,
        }
      };

      let currentWitnesses = this.witnesses;
      
      if (currentWitnesses[currentIndex].verified) {
        data.IDNoImage = this.witnesses[currentIndex].IDNoImage;
        data.KraPinImage = this.witnesses[currentIndex].KraPinImage;
        data.PassportImage = this.witnesses[currentIndex].PassportImage;
      } else {
        data.IDNoImage = {name: '', stringValue: ''};
        data.KraPinImage = {name: '', stringValue: ''};
        data.PassportImage = {name: '', stringValue: ''};
      }

      if (currentWitnesses[currentIndex].WitnessID) {
        data = {...data, ...{WitnessID: currentWitnesses[currentIndex].WitnessID}};
      }
      
      const response = await this.apiService.postRequest(
        environment.baseUrl + Constants.willWitnessURL, data);
      
      // console.log('::::: RESPONSE ::::::\n', response);
      if (response.Status === 1) {
        const latestRecord = currentWitnesses[currentIndex];
        // remove images from record to NOT replace object images!!!
        const recordValueWithoutImages = Object.fromEntries(
          Object.entries(record.getRawValue()).filter(([key]) => !key.includes('Image'))
        );
        let updatedRecord = {
          ...latestRecord,
          ...recordValueWithoutImages,
          ...{WitnessID: response.WitnessID}};

        Object.assign(currentWitnesses[currentIndex], updatedRecord);

        await this.estateControlService.updateRecordWill(6, currentWitnesses);
        
        currentWitnesses = this.witnesses;
        let currentRecord = currentWitnesses[currentIndex];
        
        if (currentRecord.verified == true) { // uploaded docs
          tsMessage = 'Witness details updated';

          if (response.IdURL) {
            this.estateControlService.removeFromDocSummary('ID', 'Witness', currentRecord.WitnessID);
            this.estateControlService.updateDocSummary(response.IdURL);
            currentRecord = {...currentRecord, ...{IDURL: response.IdURL, SavedID: currentRecord.IDNoImage}};
          }
          if (response.KraURL) {
            this.estateControlService.removeFromDocSummary('PIN', 'Witness', currentRecord.WitnessID);
            this.estateControlService.updateDocSummary(response.KraURL);
            currentRecord = {...currentRecord, ...{KraURL: response.KraURL, SavedPIN: currentRecord.KraPinImage}};
          }
          if (response.PassportURL) {
            this.estateControlService.removeFromDocSummary('PASSPORT', 'Witness', currentRecord.WitnessID);
            this.estateControlService.updateDocSummary(response.PassportURL);
            currentRecord = {...currentRecord, ...{PassportURL: response.PassportURL, SavedPassport: currentRecord.PassportImage}};
          }
          
          currentRecord.done = true;

        } else {
          currentRecord.verified = true;
          this.validationService.addOrRemoveValidator(true, this.getWitnessFormGroup(currentIndex).get('IDNoImage')!);
          if (this.region === 0)
            this.validationService.addOrRemoveValidator(true, this.getWitnessFormGroup(currentIndex).get('KraPinImage')!);
          this.validationService.addOrRemoveValidator(true, this.getWitnessFormGroup(currentIndex).get('PassportImage')!);
          
          if (this.witnesses.length <= 1 && !currentRecord.verified) this.estateControlService.updateWillProgress('Witnesses');
        }

        Object.assign(currentWitnesses[currentIndex], currentRecord);
        await this.estateControlService.updateRecordWill(6, currentWitnesses);
        this.notificationService.viewToast('success', tsMessage);
        this.updateDoneStatus(currentIndex, currentRecord)
        
        if (!environment.production) console.log('>> New Witnesses !! \n', this.estateControlService.witnesses);
      } else {
        this.notificationService.viewToast('error', response.Message);
      }
    } catch (error) {
      console.log(':: Error !! ', error);
      this.notificationService.viewToast('error', 'An unexpected error occurred');
    }
    this.notificationService.isLoading(false);
  }

  async submitForm(): Promise<void> {
    if (this.witnessFormVisible) {
      if (this.witnesses[this.witnesses.length-1].done) {
        this.navigateFunction();
      } else {
        this.saveWitness();
      }
    } else {
      if (this.addWitnesses) {
        this.populateForm();
      } else {
        this.navigateFunction();
      }
    }
  }

  async updateProgress(): Promise<void> {
    if (!this.witnesses[this.witnesses.length-1].done && this.witnessForm.valid) await this.submitForm();
    this.saveProgress();
  }

  async updateRecord(index: number) {
    await this.saveWitness(index);
  }

  async navigateFunction(): Promise<void> {
    await this.estateControlService.changeTabWill(7);
    this.estateControlService.page6Done = true;
  }


  // ==============  EXPANSION SECTION   =================
  @ViewChild('witnessInfo') witnessInfo!: TemplateRef<any>;
  @ViewChild('uploadDocs') uploadDocs!: TemplateRef<any>;


  generatePanelsForWitness = (i: number): ExpansionPanel[] => {
    // Fallback if templates not ready
    if (!this.witnessInfo || !this.uploadDocs || !this.witnesses[i]) {
      return [];
    }
    return [
      {
        title: 'Witness Information',
        contentTemplate: this.witnessInfo,
        context: { index: i },
        expanded: !(this.witnesses[i].verified),
        done: (this.witnesses[i].verified)
      },
      {
        title: 'Upload Documents',
        contentTemplate: this.uploadDocs,
        context: { index: i },
        disabled: !(this.witnesses[i].verified),
        expanded: (this.witnesses[i].verified && !this.witnesses[i].done),
        done: (this.witnesses[i].done)
      }
    ];
  }

  updateDoneStatus(i: number, value: any) {
    // Ensure panels array exists
    this.witnessPanels = this.witnessPanels || [];
    
    // Initialize if missing or invalid
    if (!this.witnessPanels[i] || this.witnessPanels[i].length !== 2) {
      this.witnessPanels[i] = this.generatePanelsForWitness(i);
    }

    const panels = this.witnessPanels[i];
    
    // Update panel states while preserving context
    if (panels[0]) {
      panels[0].done = value.verified;
      // Preserve existing context or initialize if missing
      panels[0].context = panels[0].context || { index: i };
    }
    
    if (panels[1]) {
      panels[1].done = value.detailsDone;
      panels[1].context = panels[1].context || { index: i };
      panels[1].disabled = !value.verified;
      panels[1].expanded = !value.done;
    }

    setTimeout(()=> {
      try {
        if (!value.done && value.verified && i == this.witnesses.length-1) {
          this.notificationService.viewToast(
            'info',
            `Witness ${value.FirstName} ${value.LastName}`,
            `Please continue to ${panels[1].title}`
          );
        }
      } catch (error) {}
    })
  }

  private setupFormChangeListeners() {
    this.cleanupFormChangeListeners();
    
    this.getWitnesses().controls.forEach((control, index) => {
      // General form changes
      const subscription = (control as FormGroup).valueChanges.subscribe(() => {
        this.cdr.detectChanges();
      });
      this.formChangesSubscription.push(subscription);
    });
  }
  private setupFormChangeListenersForIndex(index: number) {    
    // Clean up existing subscription if any
    const existingSub = this.formChangesSubscription[index];
    if (existingSub) {
      existingSub.unsubscribe();
    }
  }
  private cleanupFormChangeListeners() {
    this.formChangesSubscription.forEach(sub => sub.unsubscribe());
    this.formChangesSubscription = [];
  }

  private loggedErrors = new Set<string>();

  confirmFormMatchesRecord(index: number): boolean {
    try {
      const witness = this.witnesses[index];
      const formGroup = this.getWitnessFormGroup(index);
      
      if (!witness?.done || !formGroup) {
        return true;
      }

      // Fields to compare
      const fieldsToCompare = [
        'Title', 'FirstName', 'MiddleName', 'LastName', 
        'Phone', 'Email', 'IDNo', 'PostalAddress'
      ];

      const basicFieldsMatch = fieldsToCompare.every(field => {
        const recordValue = witness[field];
        const formValue = formGroup.get(field)?.value;
        const valuesMatch = (formValue || '') === (recordValue || '');
        
        // If either value is empty, consider this field as matching
        return valuesMatch;
      });

      const filesMatch =
        witness.IDNoImage.name === witness.SavedID.name &&
        witness.KraPinImage.name === witness.SavedPIN.name &&
        witness.PassportImage.name === witness.SavedPassport.name;

      return basicFieldsMatch && filesMatch;
    } catch (error: any) {
      const errorKey = `error-${index}-${error.message}`;
      if (!this.loggedErrors.has(errorKey)) {
        console.error('Error in confirmFormMatchesRecord:', error);
        this.loggedErrors.add(errorKey);
      }
      return false;
    }
  }
}
